import React from 'react'

//third party
import {
    Row,
    Col,
    Container,
    Label,
    Spinner,
    Toast,
    Input,
    CardBody,
    CardTitle,
    CardHeader,
    FormFeedback,
} from 'reactstrap'

const TermsAndCondition = () => {
    return (
        <Container>
            <p>
                Welcome to the SME and Supplier ESG Readiness Tool ("the Tool") provided by the UN Global Compact Network South Africa ("UNGCNSA"). This Tool is designed to help organizations evaluate their Environmental, Social, and Governance (ESG) practices and track their progress towards the United Nations Sustainable Development Goals (SDGs). By accessing and using this Tool, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions. If you do not agree with any part of these Terms and Conditions, please do not use the Tool.
            </p>

            <div>
                <h5 className='text-primary'>
                    Purpose and Scope:
                </h5>
                <p className='ms-3'>
                    1.1 The Tool is designed to assess organizations' ESG maturity levels, track progress, and provide insights into their sustainability practices.
                </p>
                <p className='ms-3'>
                    1.2 The Tool consists of two main assessment types:
                    <ul className='ms-4'>
                        <li>Readiness Assessment: Establishes your baseline ESG performance across all indicators</li>
                        <li>Progress Assessment: Tracks improvements and advancements in ESG practices over time</li>
                    </ul>
                </p>
                <p className='ms-3'>
                    1.3 The Tool is intended for use by organizations committed to improving their ESG practices and contributing to the SDGs.
                </p>
            </div>

            <div>
                <h5 className='text-primary'>
                    Ownership and License:
                </h5>
                <p className='ms-3'>
                    2.1 The Tool, including all associated intellectual property rights, is owned and operated by UNGCNSA.
                </p>
                <p className='ms-3'>
                    2.2 UNGCNSA grants you a limited, non-exclusive, non-transferable license to access and use the Tool for the purpose of completing assessments and evaluating your organization's ESG practices.
                </p>
                <p className='ms-3'>
                    2.3 You may not modify, copy, distribute, transmit, display, perform, reproduce, publish, license, create derivative works from, transfer, or sell any information, software, products, or services obtained from the Tool without the prior written consent of UNGCNSA.
                </p>
            </div>

            <div>
                <h5 className='text-primary'>
                    Data Collection and Privacy:
                </h5>
                <p className='ms-3'>
                    3.1 By using the Tool, you acknowledge and agree that:
                    <ul className='ms-4'>
                        <li>All information you provide will be collected, stored, and processed by UNGCNSA</li>
                        <li>Your individual data will be kept confidential</li>
                        <li>Aggregated data may be used to generate ESG maturity scores and peer benchmarks</li>
                        <li>Supporting documents uploaded for assessment validation will be securely stored</li>
                    </ul>
                </p>
                <p className='ms-3'>
                    3.2 UNGCNSA may share aggregated data with third parties for research and benchmarking purposes, provided that such sharing complies with applicable data protection laws and regulations.
                </p>
                <p className='ms-3'>
                    3.3 While UNGCNSA implements reasonable security measures, you acknowledge that no internet transmission or electronic storage system is completely secure. UNGCNSA shall not be liable for any unauthorized access, disclosure, alteration, loss, damage, or misuse of data.
                </p>
            </div>

            <div>
                <h5 className='text-primary'>
                    Assessment Process and Results:
                </h5>
                <p className='ms-3'>
                    4.1 You are responsible for:
                    <ul className='ms-4'>
                        <li>Providing accurate and truthful information in your assessments</li>
                        <li>Maintaining the confidentiality of your account credentials</li>
                        <li>Ensuring all uploaded supporting documents are authentic and relevant</li>
                    </ul>
                </p>
                <p className='ms-3'>
                    4.2 Assessment results are based on self-reported data and may not fully reflect your organization's actual ESG performance. The Tool provides indicative scores and should not be considered as a definitive measure of ESG maturity.
                </p>
                <p className='ms-3'>
                    4.3 You acknowledge that the Tool's scoring methodology and assessment criteria may be updated periodically to reflect evolving ESG standards and best practices.
                </p>
            </div>

            <div>
                <h5 className='text-primary'>
                    Disclaimer of Warranties:
                </h5>
                <p className='ms-3'>
                    5.1 The Tool is provided "as-is" and "as-available" without any warranties, express or implied.
                </p>
                <p className='ms-3'>
                    5.2 UNGCNSA does not warrant that:
                    <ul className='ms-4'>
                        <li>The Tool will be error-free or uninterrupted</li>
                        <li>The Tool will be free from viruses or harmful components</li>
                        <li>The assessment results will be accurate or suitable for your specific needs</li>
                    </ul>
                </p>
                <p className='ms-3'>
                    5.3 The Tool is not intended to provide professional advice or replace expert consultation on ESG matters.
                </p>
            </div>

            <div>
                <h5 className='text-primary'>
                    Limitation of Liability:
                </h5>
                <p className='ms-3'>
                    6.1 To the maximum extent permitted by law, UNGCNSA shall not be liable for any direct, indirect, incidental, consequential, or special damages arising from your use of the Tool.
                </p>
                <p className='ms-3'>
                    6.2 You agree to indemnify and hold UNGCNSA harmless from any claims arising from your use of the Tool or violation of these Terms and Conditions.
                </p>
                <p className='ms-3'>
                    6.3 UNGCNSA is not responsible for any decisions or actions taken based on the Tool's assessment results or recommendations.
                </p>
            </div>

            <div>
                <h5 className='text-primary'>
                    Account Management:
                </h5>
                <p className='ms-3'>
                    7.1 You are responsible for maintaining the confidentiality of your account and password.
                </p>
                <p className='ms-3'>
                    7.2 You must notify UNGCNSA immediately of any unauthorized use of your account or security breaches.
                </p>
                <p className='ms-3'>
                    7.3 UNGCNSA reserves the right to suspend or terminate accounts that violate these Terms and Conditions.
                </p>
            </div>

            <div>
                <h5 className='text-primary'>
                    Modifications and Updates:
                </h5>
                <p className='ms-3'>
                    8.1 UNGCNSA reserves the right to modify or discontinue the Tool at any time, with or without notice.
                </p>
                <p className='ms-3'>
                    8.2 These Terms and Conditions may be updated periodically. Your continued use of the Tool after any modifications constitutes acceptance of the updated terms.
                </p>
            </div>

            <div>
                <h5 className='text-primary'>
                    Governing Law and Jurisdiction:
                </h5>
                <p className='ms-3'>
                    9.1 These Terms and Conditions shall be governed by and construed in accordance with the laws of South Africa.
                </p>
                <p className='ms-3'>
                    9.2 Any disputes arising from these Terms and Conditions shall be subject to the exclusive jurisdiction of the courts of South Africa.
                </p>
            </div>

            <div>
                <h5 className='text-primary'>
                    Contact Information:
                </h5>
                <div className='ms-3'>
                    <p className='mb-2'><strong>Our Address:</strong></p>
                    <p className='ms-3 mb-3'>
                        26 Melville Road, Johannesburg,<br />
                        South Africa
                    </p>

                    <p className='mb-2'><strong>How to Reach Us:</strong></p>
                    <p className='ms-3 mb-1'>Phone: +27 11 771 41 42</p>
                    <p className='ms-3 mb-1'>Email: info@globalcompactsa.org.za</p>
                    <p className='ms-3 mb-3'>Technical Support: tech@creativebox.world</p>

                    <p className='mb-2'><strong>Opening Hours:</strong></p>
                    <p className='ms-3 mb-1'>Monday to Friday: 08:30 – 16:30</p>
                    <p className='ms-3 mb-3'>Saturday, Sunday & Public Holidays: Closed</p>
                </div>
            </div>

            <div>
                <p className='fw-bold'>
                    By using the SME and Supplier ESG Readiness Tool, you agree to these Terms and Conditions. If you do not agree, please refrain from using the Tool.
                </p>
            </div>
        </Container>
    )
};

export default TermsAndCondition